<template>
  <v-ons-splitter>
    <v-ons-splitter-side
      swipeable width="75%" collapse="" side="left"
    >
      <v-ons-page>
        <v-ons-list>
        <ons-list-title><img src="../public/logo.png" alt="Nature" class="responsive"></ons-list-title>
        <ons-list-header>{{rep}}</ons-list-header>
          <v-ons-list-item v-for="item in essentialLinks" @click="goTo(item.routeName)" :key="item.routeName">
            <div class="left">
              <v-ons-icon fixed-width :icon="item.icon"></v-ons-icon>
              <span style="padding-left: 10px;">{{ item.label }}</span>
            </div>

          </v-ons-list-item>
          </v-ons-list>
        <v-ons-list>
        </v-ons-list>
      </v-ons-page>
    </v-ons-splitter-side>

  <v-ons-splitter-content>
    <router-view></router-view>
  </v-ons-splitter-content>
</v-ons-splitter>
</template>

<script>
import store from './store';
export default {
  name: 'app',
  data() {
    return {
      rep: localStorage.getItem('fullname'),
      essentialLinks: [
        {
          label: 'Clientes',
          routeName: 'Clientes',
          icon: 'fa-user',
        },
        {
          label: 'Orçamentos',
          routeName: 'ConsultaOrcamento',
          icon: 'fa-money',
        },
      ],
    };
  },
  methods: {
    goTo(routeName) {
      this.$router.push({ name: routeName });
    },
    logout: function() {
            this.$store
              .dispatch("logout")
              .then(() => this.$router.push("/login"))
              .catch(err => console.log(err));
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
